// ONE STATUS MODEL in the browser: every screen reads GET /system-status (AppContext.systemStatus) through these
// helpers instead of deriving its own "connected" / "live" from different fields (UI/UX audit Phase 2).
// The server decides (backend/status_model.py); this file only words and colours it.

// feed state -> badge text and tone
export const FEED = {
  LIVE: { text: "MARKET DATA LIVE", tone: "good" },
  CLOSED: { text: "MARKETS CLOSED", tone: "idle" },
  STALE: { text: "MARKET DATA STALE", tone: "bad" },
  WAITING: { text: "WAITING FOR TICKS", tone: "warn" },
  CONNECTING: { text: "MARKET DATA CONNECTING", tone: "warn" },
  NO_SUBSCRIPTIONS: { text: "NOTHING SUBSCRIBED", tone: "warn" },
  DISCONNECTED: { text: "ZERODHA DISCONNECTED", tone: "bad" },
};

export const TONE_CLASS = {
  good: "bg-[#00C805]/15 text-[#00C805] border-[#00C805]/40",
  idle: "bg-[#1A1D24] text-slate-300 border-[#2A2F3A]",
  warn: "bg-[#FFCC00]/10 text-[#FFCC00] border-[#FFCC00]/30",
  bad: "bg-[#FF3B30]/15 text-[#FF6b62] border-[#FF3B30]/40",
};

/** {feed, text, tone, title} of the market-data badge, or null while the status has not loaded. */
export function marketBadge(systemStatus) {
  const m = systemStatus?.market;
  if (!m) return null;
  const f = FEED[m.feed] || { text: m.feed, tone: "idle" };
  const lines = Object.entries(m.exchanges || {}).map(([ex, v]) =>
    `${ex}: ${v.open ? "open" : `closed (${(v.reason || "").replace(/_/g, " ").toLowerCase()})`}` +
    (v.opens ? ` · session ${v.opens}–${v.closes}` : "") +
    (v.last_trade_label ? ` · last trade ${v.last_trade_label}` : ""));
  return { feed: m.feed, text: f.text, tone: f.tone, label: m.label, title: [m.label, ...lines].join("\n") };
}

/** Why futures trades are waiting, worded from the one status: not connected / markets closed / data not live.
 *  {tone, title, sub, broker} - broker: offer the Broker Session button. null while loading. */
export function marketWait(systemStatus) {
  if (!systemStatus) return null;
  const z = systemStatus.zerodha_session;
  if (z !== "CONNECTED") {
    return { tone: "bad", broker: true, title: `Zerodha ${z || "not connected"} — PAPER needs Zerodha market data.`,
      sub: "Connect via the extension; trades remain stopped safely." };
  }
  const m = systemStatus.market || {};
  if (m.feed === "CLOSED") {
    return { tone: "idle", broker: false, title: m.label || "Markets closed",
      sub: "Trades wait for the next session: nothing is entered while the market is closed." };
  }
  return { tone: "warn", broker: false, title: m.label || "Market data is not live",
    sub: "Trades wait until prices are fresh: nothing is entered on stale data." };
}

/** Header warnings: the server's list plus the browser-only ones (parity, exits in progress), most severe first. */
export function headerWarnings(systemStatus, extra = []) {
  const order = { critical: 0, warning: 1, info: 2 };
  return [...(systemStatus?.warnings || []), ...extra.filter(Boolean)]
    .sort((a, b) => (order[a.severity] ?? 3) - (order[b.severity] ?? 3));
}
